import React, { CSSProperties } from 'react';

import { LoadingButton } from '@atlaskit/button';
import type { LoadingButtonProps } from '@atlaskit/button';
import Tooltip from '@atlaskit/tooltip';
import type { TooltipProps } from '@atlaskit/tooltip';

export type Props = {
  tooltipProps: Omit<TooltipProps, 'children'>;
  loadingButtonProps: LoadingButtonProps;
  children?: React.ReactNode;
};

// This component is a hack to make a disabled button working with tooltip
// See: https://mui.com/material-ui/react-tooltip/#disabled-elements
// It is for MUI, but the principle is the same.

export default function LoadingButtonWithTooltip({
  tooltipProps,
  loadingButtonProps,
  children,
}: Props): JSX.Element {
  const getStyles = (): {
    wrapperStyle: CSSProperties;
    buttonStyle: CSSProperties;
  } => {
    if (loadingButtonProps?.isDisabled) {
      return {
        wrapperStyle: {
          cursor: 'not-allowed',
        },
        buttonStyle: {
          ...loadingButtonProps.style,
          pointerEvents: 'none',
        },
      };
    }

    return {
      wrapperStyle: null,
      buttonStyle: loadingButtonProps.style,
    };
  };

  const { wrapperStyle, buttonStyle } = getStyles();

  return (
    <Tooltip {...tooltipProps}>
      <span style={wrapperStyle}>
        <LoadingButton {...loadingButtonProps} style={buttonStyle}>
          {children}
        </LoadingButton>
      </span>
    </Tooltip>
  );
}
